import { createReducer, on } from "@ngrx/store";
import { Form } from "../../../domain/form.interface";
import { Pagination } from "../../../domain/pagination.interface";
import { FormState } from "../states/form.state";

import {
  loadFormsList,
  loadFormsListSuccess,
  loadFormsListFailure,
  getSelectedForm,
  getSelectedFormSuccess,
  getSelectedFormFailure,
  deleteForm,
  deleteFormSuccess,
  deleteFormFailure,
  addForm,
  addFormSuccess,
  addFormFailure,
  editForm,
  editFormFailure,
  editFormSuccess,
  cloneForm,
  cloneFormFailure,
  cloneFormSuccess,
  newForm,
} from "../actions/form.actions";
import { addVersionSuccess, deleteVersionSuccess, editVersionSuccess } from "../actions/version.actions";

export const initialPagination: Pagination = {
  total: 0,
  pages: 1,
  next: null,
  previous: null,
  current: 1,
  entries: 50,
};

export const initialState: FormState = {
  forms: null,
  selectedForm: null,
  isNewForm: false,
  error: null,
  listStatus: "pending",
  getStatus: "pending",
  createStatus: "pending",
  updateStatus: "pending",
  deleteStatus: "pending",
  cloneStatus: "pending",
  pagination: initialPagination
};

export const formReducer = createReducer(
  // Supply the initial state
  initialState,
  // Handle new
  on(newForm, (state, { newForm }) => ({
    ...state,
    isNewForm: newForm
  })),
  // Handle list
  on(loadFormsList, (state) => ({
    ...state,
    listStatus: "loading" as FormState["listStatus"],
  })),
  // Handle successfully list
  on(loadFormsListSuccess, (state, { data }) => {
    let tempPagination = {} as Pagination
    tempPagination.total = data.total;
    tempPagination.pages = data.pages;
    tempPagination.next = data.next;
    tempPagination.previous = data.previous;
    tempPagination.current = data.current;
    tempPagination.entries = data.entries;
    return {
      ...state,
      forms: data.results,
      error: null,     
      pagination: tempPagination,
      listStatus: "success" as FormState["listStatus"]
    }
  }),
  // Handle failure list
  on(
    loadFormsListFailure,
    (state, { error }) => ({
    ...state,
    error: error,
    listStatus: "error" as FormState["listStatus"],
  })),
  // Handle get selected
  on(getSelectedForm, (state) => ({
    ...state,
    getStatus: "loading" as FormState["getStatus"],
  })),
  // Handle successfully get selected
  on(getSelectedFormSuccess, (state, { form }) => {
    let tempPagination = {} as Pagination
    let tempForm = {...form};
    console.log('FORM->', form)
    if(form.pk == 'form') {
      tempPagination.total = form.versions['total'];
      tempPagination.pages = form.versions['pages'];
      tempPagination.next = form.versions['next'];
      tempPagination.previous = form.versions['previous'];
      tempPagination.current = form.versions['current'];
      tempPagination.entries = form.versions['entries'];
      let tempVersionsResult = form.versions.results;
      tempForm.versions = {
        pagination: tempPagination,
        results: tempVersionsResult
      };
    }
    return {
      ...state,
      selectedForm: tempForm,
      error: null,
      getStatus: "success" as FormState["getStatus"]
    }
  }),
  // Handle failure get
  on(
    getSelectedFormFailure,
    (state, { error }) => ({
    ...state,
    error: error,
    getStatus: "error" as FormState["getStatus"],
  })),
   // Handle delete
   on(deleteForm, (state) => ({
    ...state,
    deleteStatus: "loading" as FormState["deleteStatus"]
  })),
  // Handle successfully delete
  on(deleteFormSuccess, (state, { pk, sk }) => ({
    ...state,
    deleteStatus: "success" as FormState["deleteStatus"],
    selectedForm: state.selectedForm.sk == sk ? null : state.selectedForm,
    forms: [...state.forms.filter((form) => form.sk !== sk)],
    pagination : {
      ...state.pagination,
      total: state.pagination.total - 1
   },
  })),
  // Handle failure delete
  on(
    deleteFormFailure,
    (state, { error }) => ({
    ...state,
    error: error,
    deleteStatus: "error" as FormState["deleteStatus"],
  })),
  // Handle add
  on(addForm, (state) => ({
    ...state,
    createStatus: "loading" as FormState["createStatus"]
  })),
  // Handle successfully add
  on(addFormSuccess, (state, { form }) => {
    let tempPagination = initialPagination;
    let tempForm = {...form};
    tempForm['versions'] = {
      pagination: tempPagination,
      results: []
    };
    return {
      ...state,
      forms: [tempForm, ...state.forms],
      selectedForm: tempForm,
      pagination : {
        ...state.pagination,
        total: state.pagination.total + 1
      },
      createStatus: "success" as FormState["createStatus"]
    }
  }),
  // Handle failure add
  on(
    addFormFailure,
    (state, { error }) => ({
    ...state,
    error: error,
    createStatus: "error" as FormState["createStatus"],
  })),
  // Handle edit
  on(editForm, (state) => ({
    ...state,
    updateStatus: "loading" as FormState["updateStatus"]
  })),
  // Handle successfully edit
  on(editFormSuccess, (state, { form }) => ({
    ...state,
    forms: state.forms.map((formItem) =>
      formItem.sk === form.sk && formItem.pk === form.pk ? form : formItem
    ),
    selectedForm: form,
    updateStatus: "success" as FormState["updateStatus"]
  })),
  // Handle failure edit
  on(
    editFormFailure,
    (state, { error }) => ({
    ...state,
    error: error,
    updateStatus: "error" as FormState["updateStatus"],
  })),
  // Handle clone
  on(cloneForm, (state) => ({
    ...state,
    cloneStatus: "loading" as FormState["cloneStatus"]
  })),
  // Handle successfully clone
  on(cloneFormSuccess, (state, { form }) => {
    let tempPagination = initialPagination;
    let tempForm = {...form};
    tempForm['versions'] = {
      pagination: tempPagination,
      results: []
    };
    return {
      ...state,
      forms: [tempForm, ...state.forms],
      selectedForm: tempForm,
      pagination : {
        ...state.pagination,
        total: state.pagination.total + 1
      },
      cloneStatus: "success" as FormState["cloneStatus"]
    }
  }),
  // Handle failure clone
  on(
    cloneFormFailure,
    (state, { error }) => ({
    ...state,
    error: error,
    cloneStatus: "error" as FormState["cloneStatus"],
  })),
  // Handle add version on selected form
  /*on(addVersionSuccess, (state, { version }) => {
    let tempVersion = {...version}

    let versions = {
      ...state.selectedForm.versions,
      pagination : {
        ...state.selectedForm.versions.pagination,
        total: state.selectedForm.versions.pagination.total + 1
      },
      results : [version, ...state.selectedForm.versions.results]
    }

    tempVersion['versions'] = versions

    return {
      ...state,
      selectedForm: version,     
    }
  }),*/
  // Handle delete version on selected form versions
  /*on(editVersionSuccess, (state, { version }) => {    
    return {
      ...state,
      selectedForm: version
    }
  }),*/
);

